/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useContext } from 'react';
import SuperAppContext from './SuperAppContext';

const useSuperAppContext = () => {
  return useContext(SuperAppContext);
};

export default useSuperAppContext;
